(function () {
  "use strict";

  var SELECTOR = "[data-soft-life-oil-mood]";

  function findClosest(element, selector) {
    while (element && element.nodeType === 1) {
      if (element.matches && element.matches(selector)) {
        return element;
      }
      element = element.parentElement;
    }
    return null;
  }

  function safeFocus(element) {
    if (!element) {
      return;
    }

    element.setAttribute("tabindex", "-1");

    try {
      element.focus({ preventScroll: true });
    } catch (error) {
      element.focus();
    }
  }

  function smoothScrollTo(element) {
    if (!element || !element.scrollIntoView) {
      return;
    }

    try {
      element.scrollIntoView({
        behavior: "smooth",
        block: "nearest"
      });
    } catch (error) {
      element.scrollIntoView();
    }
  }

  function replaceStageContent(stage, fragment) {
    while (stage.firstChild) {
      stage.removeChild(stage.firstChild);
    }
    stage.appendChild(fragment);
  }

  function initOilMood(root) {
    var stage;
    var resultTemplate;
    var pickerMarkup;

    if (!root || root.getAttribute("data-sl-mood-initialized") === "true") {
      return;
    }

    stage = root.querySelector("[data-stage]");
    resultTemplate = root.querySelector("[data-result-template]");

    if (!stage || !resultTemplate) {
      return;
    }

    root.setAttribute("data-sl-mood-initialized", "true");
    pickerMarkup = stage.innerHTML;

    function restorePicker() {
      var prompt;

      stage.innerHTML = pickerMarkup;
      prompt = stage.querySelector(".sl-mood-prompt");

      safeFocus(prompt);
      smoothScrollTo(stage);
    }

    function showResult(card) {
      var fragment;
      var mountedResult;
      var heading;
      var link;
      var buttonText;
      var image;
      var placeholder;
      var mood;
      var oilName;
      var collection;
      var moodWords;
      var notes;
      var why;
      var productUrl;
      var buttonLabel;
      var imageUrl;
      var imageAlt;

      if (!card || !resultTemplate.content) {
        return;
      }

      fragment = resultTemplate.content.cloneNode(true);

      mood = card.getAttribute("data-mood-label") || "";
      oilName = card.getAttribute("data-oil-name") || "";
      collection = card.getAttribute("data-collection") || "";
      moodWords = card.getAttribute("data-mood-words") || "";
      notes = card.getAttribute("data-notes") || "";
      why = card.getAttribute("data-why") || "";
      productUrl = card.getAttribute("data-product-url") || "/collections/all";
      buttonLabel = card.getAttribute("data-button-label") || ("Shop " + oilName);
      imageUrl = card.getAttribute("data-image-url") || "";
      imageAlt = card.getAttribute("data-image-alt") || oilName;

      fragment.querySelector("[data-result-mood]").textContent = mood.toLowerCase();
      fragment.querySelector("[data-result-name]").textContent = oilName;
      fragment.querySelector("[data-result-collection]").textContent = collection;
      fragment.querySelector("[data-result-words]").textContent = moodWords;
      fragment.querySelector("[data-result-notes]").textContent = notes;
      fragment.querySelector("[data-result-why]").textContent = why;

      link = fragment.querySelector("[data-result-link]");
      buttonText = fragment.querySelector("[data-result-button]");

      if (link) {
        link.setAttribute("href", productUrl);
      }

      if (buttonText) {
        buttonText.textContent = buttonLabel;
      }

      image = fragment.querySelector("[data-result-image]");
      placeholder = fragment.querySelector("[data-image-placeholder]");

      if (imageUrl && image) {
        image.setAttribute("src", imageUrl);
        image.setAttribute("alt", imageAlt);
        image.hidden = false;

        if (placeholder) {
          placeholder.hidden = true;
        }
      } else {
        if (image) {
          image.hidden = true;
        }

        if (placeholder) {
          placeholder.hidden = false;
        }
      }

      replaceStageContent(stage, fragment);

      mountedResult = stage.querySelector("[data-result]");

      if (mountedResult) {
        window.setTimeout(function () {
          mountedResult.classList.add("is-visible");
        }, 20);
      }

      heading = stage.querySelector("[data-result-name]");
      safeFocus(heading);
      smoothScrollTo(stage);
    }

    root.addEventListener("click", function (event) {
      var target = event.target;
      var moodCard = findClosest(target, "[data-mood-card]");
      var tryAgain;

      if (moodCard && root.contains(moodCard)) {
        showResult(moodCard);
        return;
      }

      tryAgain = findClosest(target, "[data-try-again]");

      if (tryAgain && root.contains(tryAgain)) {
        restorePicker();
      }
    });
  }

  function initAll(scope) {
    var container = scope || document;
    var sections = container.querySelectorAll(SELECTOR);
    var index;

    for (index = 0; index < sections.length; index += 1) {
      initOilMood(sections[index]);
    }
  }

  function start() {
    initAll(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
}());
